import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { UpdateAccessRolePayload } from "../types/AccessRole";

interface Params extends UpdateAccessRolePayload {
  id: number;
}

/** PATCH `/user/access_role/{id}/` — body shape confirmed against a real request sample: `{description, permissions, users}` (no `name`/`scope` — those are set only at creation). */
export const useUpdateAccessRole = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    const { id, ...body } = params;

    return axios.patch(`${env.verifyServiceUrl}user/access_role/${id}/`, body, {
      headers: {
        Authorization: authHeader,
      },
    });
  });
};
